import { DIVIDER_PATHS } from '../utils';

const WAVE_TYPES = ['wave', 'wave-smooth', 'multi-wave', 'cloud'];

export default function SectionDivider({ type, color = '#ffffff', position = 'bottom', height = 48, animated = false, gradientFrom, gradientTo, config }) {
    if (!type || !DIVIDER_PATHS[type]) return null;
    const path = DIVIDER_PATHS[type];
    const isTop = position === 'top';
    // Allow config prop to provide animated/gradient settings (so existing sections get features without code changes)
    const _animated = animated || (config?.divider_animated);
    const _gradFrom = gradientFrom || config?.divider_gradient_from;
    const _gradTo = gradientTo || config?.divider_gradient_to;
    const shouldAnimate = _animated && WAVE_TYPES.includes(type);
    const hasGradient = _gradFrom && _gradTo;
    const gradientId = hasGradient ? `divider-grad-${type}-${position}` : null;
    const fillValue = hasGradient ? `url(#${gradientId})` : color;

    return (
        <div className={`absolute left-0 right-0 overflow-hidden pointer-events-none ${isTop ? 'top-0' : 'bottom-0'}`}
            style={{ height, transform: isTop ? 'rotate(180deg)' : undefined, marginBottom: isTop ? undefined : -1, marginTop: isTop ? -1 : undefined }}>
            {shouldAnimate ? (
                <div className="absolute bottom-0 w-full" style={{ height, overflow: 'hidden' }}>
                    <svg viewBox="0 0 2880 128" preserveAspectRatio="none"
                        style={{ height, width: '200%', animation: 'dividerFlow 8s linear infinite' }}>
                        {hasGradient && (
                            <defs>
                                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" stopColor={_gradFrom} />
                                    <stop offset="100%" stopColor={_gradTo} />
                                </linearGradient>
                            </defs>
                        )}
                        <path d={path} fill={fillValue} />
                        <path d={path} fill={fillValue} transform="translate(1440, 0)" />
                    </svg>
                    <style>{`@keyframes dividerFlow { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
                </div>
            ) : (
                <svg viewBox="0 0 1440 128" preserveAspectRatio="none" className="absolute bottom-0 w-full" style={{ height }}>
                    {hasGradient && (
                        <defs>
                            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor={_gradFrom} />
                                <stop offset="100%" stopColor={_gradTo} />
                            </linearGradient>
                        </defs>
                    )}
                    <path d={path} fill={fillValue} />
                </svg>
            )}
        </div>
    );
}
